import styled, { css } from 'styled-components';

import {
    IconSuccess,
    mediaMixin,
    spaceMixin,
    Text,
    token,
} from '@zillow/constellation';

export const StyledContainer = styled.div`
    border-top: 1px solid ${token('colors.gray300')};
    display: flex;
    padding: ${spaceMixin('sm')};

    &:last-child {
        border-bottom: 1px solid ${token('colors.gray300')};
    }
`;

export const StyledGrayText = styled(Text)`
    && {
        color: #596B82;
        display: block;
        font-size: 14px;
    }
`;

export const StyledDesktopStatusText = styled(Text)`
    && {
        display: none;

        ${mediaMixin('lg', css`
            color: #596B82;
            display: block;
            font-size: 14px;
            font-weight: 600;
    `)}
    }
`;

export const StyledMobileStatusText = styled(Text)`
    && {
        color: #596B82;
        display: block;
        font-size: 14px;
        font-weight: 600;

        ${mediaMixin('lg', css`
            display: none;
        `)}
    }
`;

export const StyledIconContainer = styled.div`
    && {
        width: 30px;
        margin-right: ${spaceMixin('sm')};
    }
`;

export const StyledSuccessIcon = styled(IconSuccess)`
    && {
        color: ${token('colors.green400')};
        margin-right: ${spaceMixin('xs')};
    }
`;
